@if (workspaceView$ | async; as workspaceView) {
	<div (stagesClickOutside)="closeNavigation()" role="navigation">
		<div
			class="workspace-nav primary"
			[ngClass]="{
				visible: applicationState.workspaceNavigationOpen,
				'bottom-72': applicationState.secondaryWorkspaceNavigationOpen && applicationState.secondaryWorkspaceEnabled,
			}"
		>
			<div
				class="workspace-divider animate"
				[ngClass]="{ 'shadow-border': applicationState.secondaryWorkspaceNavigationOpen }"
			></div>
			<header class="primary-header" [ngClass]="{ open: applicationState.secondaryWorkspaceEnabled }">
				<div class="workspace-selection-area">
					<button
						[attr.title]="'navigation.workspace.select' | translate"
						[attr.aria-label]="'navigation.workspace.select' | translate"
						class="action nav-button"
						(click)="applicationState.toggleWorkspaceNavigation()"
					>
						<i class="ico ico-workspace"></i>
					</button>
					<div class="title" (click)="applicationState.toggleWorkspaceNavigation()">
						<span class="h3 shorten">{{ workspaceView.currentWorkspace.name }}</span>
						@if (parentExists($any(workspaceView.currentWorkspace)) && getSecondaryMode() !== "compare") {
							<span class="h6 shorten">
								{{ getParentName($any(workspaceView.currentWorkspace)) }}
							</span>
						}
						@if (getSecondaryMode() === "compare") {
							<span class="h6 shorten">
								{{ getVersionName(workspaceView.currentWorkspace.viewedProcess) }}
							</span>
						}
					</div>
					@if (applicationState.secondaryWorkspaceEnabled) {
						<button
							[attr.aria-label]="'close' | translate"
							[attr.title]="'close' | translate"
							class="workspace-close-button"
							(click)="restoreSecondaryView()"
						>
							<div>
								<i class="ico ico-close"></i>
							</div>
						</button>
					}
				</div>
			</header>
			<div class="animate defer">
				@if (applicationState.workspaceNavigationOpen) {
					<stages-workspace-selection
						activeTabPreferenceKey="WorkspaceNavigationComponent.activeTab"
						(selectWorkspace)="onSelectWorkspace($event)"
						[bookmarkable]="true"
						[selected]="workspaceView.currentWorkspace.id"
						animate.enter="stages-slide-in-from-left"
						animate.leave="stages-slide-out-to-left"
					></stages-workspace-selection>
				}
			</div>
		</div>
		@if (applicationState.secondaryWorkspaceEnabled) {
			<div
				class="workspace-nav secondary animate"
				[ngClass]="{ visible: applicationState.secondaryWorkspaceNavigationOpen }"
				animate.enter="stages-slide-in-from-left"
				animate.leave="stages-slide-out-to-left"
			>
				<header>
					<div class="workspace-selection-area">
						<button
							disabled
							[attr.title]="'notaccessible' | translate"
							[attr.aria-label]="'notaccessible' | translate"
							class="action nav-button"
						>
							<i class="ico" [ngClass]="getSecondaryMode() === 'compare' ? 'ico-interface' : 'ico-workspace'"></i>
						</button>
						<div class="title">
							<span class="h3 shorten">{{ workspaceView.secondaryWorkspace.name }}</span>
							@if (parentExists($any(workspaceView.secondaryWorkspace)) && getSecondaryMode() !== "compare") {
								<span class="h6 shorten">
									{{ getParentName($any(workspaceView.secondaryWorkspace)) }}
								</span>
							}
							@if (getSecondaryMode() === "compare") {
								<span class="h6 shorten">
									{{ getVersionName(workspaceView.secondaryWorkspace.viewedProcess) }}
								</span>
							}
						</div>
					</div>
				</header>
			</div>
		}
	</div>
}
